var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#4F4F4F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9698 8.58555C7.87711 9.1147 7.69338 9.5583 7.41862 9.91635C7.14386 10.2744 6.81034 10.5445 6.41806 10.7267C6.02578 10.9089 5.60619 11 5.15929 11C4.68259 11 4.26879 10.901 3.91789 10.7029C3.56699 10.5049 3.31127 10.215 3.15071 9.83317C2.99016 9.45136 2.95788 8.98479 3.05388 8.43346C3.14326 7.90431 3.32534 7.45913 3.6001 7.09791C3.87486 6.73669 4.21003 6.4634 4.60563 6.27804C5.00122 6.09268 5.42412 6 5.87433 6C6.34771 6 6.75903 6.09981 7.10827 6.29943C7.45917 6.49905 7.71407 6.79135 7.87297 7.17633C8.03352 7.56131 8.0658 8.03105 7.9698 8.58555ZM6.57944 8.43346C6.62578 8.15463 6.6291 7.92015 6.58937 7.73004C6.54965 7.53834 6.46606 7.39417 6.33861 7.29753C6.21116 7.1993 6.03985 7.15019 5.82467 7.15019C5.5797 7.15019 5.36287 7.20722 5.17418 7.32129C4.98549 7.43536 4.82908 7.59933 4.70494 7.81321C4.5808 8.02709 4.4939 8.28454 4.44424 8.58555C4.39128 8.86755 4.38631 9.10203 4.42935 9.28897C4.47404 9.47592 4.56176 9.61613 4.69252 9.7096C4.82494 9.80307 4.99708 9.84981 5.20894 9.84981C5.4506 9.84981 5.66412 9.79436 5.8495 9.68346C6.03654 9.57256 6.1913 9.41176 6.31378 9.20105C6.43792 8.99034 6.52647 8.73447 6.57944 8.43346Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34115 10.9335L9.1853 6.06654H11.3801C11.7575 6.06654 12.0753 6.13783 12.3335 6.28042C12.5917 6.423 12.7771 6.62342 12.8896 6.88165C13.0022 7.13989 13.0286 7.4417 12.9691 7.78707C12.9095 8.13878 12.7771 8.44217 12.5718 8.69724C12.3682 8.95073 12.1084 9.14639 11.7922 9.28422C11.4777 9.42047 11.1252 9.48859 10.7346 9.48859H9.42364L9.6024 8.46198H10.6352C10.8008 8.46198 10.9464 8.43504 11.0722 8.38118C11.198 8.32573 11.2998 8.2481 11.3776 8.14829C11.4554 8.04689 11.5059 7.92649 11.529 7.78707C11.5522 7.64766 11.5415 7.52883 11.4968 7.43061C11.4537 7.3308 11.3793 7.25475 11.2733 7.20247C11.169 7.14861 11.0358 7.12167 10.8736 7.12167H10.387L9.72158 10.9335H8.34115Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOp);
export default __webpack_public_path__ + "static/media/op.2b97feb60b07afe5de1e8a01827e5947.svg";
export { ForwardRef as ReactComponent };